import type { CardTemplate } from '@nudge/shared';
import { BottomSheet } from '../ui/BottomSheet';

interface Props {
  template: CardTemplate | null;
  canEdit: boolean;
  onClose: () => void;
  onEdit: () => void;
  onArchive: () => void;
  onToggleFavorite: () => void;
}

export function CardActionsMenu({ template, canEdit, onClose, onEdit, onArchive, onToggleFavorite }: Props) {
  return (
    <BottomSheet open={!!template} onClose={onClose}>
      {template && (
        <div className="px-6 pb-8 pt-2">
          <div className="flex items-center gap-3 pb-3">
            <span className="text-3xl" aria-hidden>{template.icon}</span>
            <div>
              <div className="text-base font-medium text-text-primary">{template.label}</div>
              {template.subtext && <div className="text-xs text-text-muted">{template.subtext}</div>}
            </div>
          </div>
          <div className="space-y-2">
            <button onClick={onToggleFavorite} className="w-full rounded-xl border border-border-subtle bg-card py-3 text-sm text-text-primary">
              {template.is_favorite ? 'Remove from Favourites' : 'Add to Favourites'}
            </button>
            {canEdit ? (
              <button onClick={onEdit} className="w-full rounded-xl border border-border-subtle bg-card py-3 text-sm text-text-primary">
                Edit card
              </button>
            ) : (
              <div className="rounded-xl border border-border-subtle bg-card py-3 text-center text-xs text-text-muted">
                Default cards can't be edited
              </div>
            )}
            {canEdit && (
              <button onClick={onArchive} className="w-full rounded-xl border border-rose/40 bg-rose/10 py-3 text-sm text-rose">
                Archive card
              </button>
            )}
            <button onClick={onClose} className="w-full py-2 text-sm text-text-muted">Cancel</button>
          </div>
        </div>
      )}
    </BottomSheet>
  );
}
